const CurrencySymbol = {
  USD: '$',
  AUD: 'A$',
  GBP: '￡',
  CAD: 'CA$',
  EUR: '€',
  NZD: 'NZ$',
};

export default CurrencySymbol;
